import {
    updateFontColor,
    updateFontFamily,
    updateFontSize,
    updateFontStyle,
    updateFontWeight,
    updateUnderline,
} from '@/infrastructure/engine2d/text/textMutations';
import type { TSelectionRange } from '@/domain/textbox/TSelectionRange';
import type { TTextStylePatch } from '@/domain/textbox/TTextStylePatch';
import type { TTextStyleResult } from '@/domain/textbox/TTextStyleResult';
import type { TTextStyles } from '@/domain/textbox/TTextStyles';
import type { IFabricTextCustom } from '@/infrastructure/engine2d/types/IFabricTextCustom';
import type { ITextboxCustom } from '@/infrastructure/engine2d/types/ITextboxCustom';
import type { Canvas } from 'fabric';

type TApplyTextStyleParams = {
    fabricCanvas: Canvas;
    fText: IFabricTextCustom & ITextboxCustom;
    patch: TTextStylePatch;
    range?: TSelectionRange;
};

// Returns the resulting styles map plus — for fontSize / italic which
// reflow the textbox — the new position for the controller to mirror.
function applyTextStyleToFabric(params: TApplyTextStyleParams): TTextStyleResult {
    const { fabricCanvas, fText, patch, range } = params;
    const args = { fabricCanvas, fText, selectedTextIndexes: range };
    let position: TTextStyleResult['position'];

    if (patch.color !== undefined) {
        updateFontColor({ ...args, fontColor: patch.color });
    }
    if (patch.fontFamily !== undefined) {
        updateFontFamily({ ...args, fontFamily: patch.fontFamily });
    }
    if (patch.fontSize !== undefined) {
        updateFontSize({ ...args, fontSize: patch.fontSize });
        position = { x: fText.left, y: fText.top };
    }
    if (patch.isBold !== undefined) {
        updateFontWeight({ ...args, fontWeight: patch.isBold ? '700' : '300' });
    }
    if (patch.isItalic !== undefined) {
        updateFontStyle({ ...args, fontStyle: patch.isItalic ? 'italic' : 'normal' });
        position = { x: fText.left, y: fText.top };
    }
    if (patch.isUnderlined !== undefined) {
        updateUnderline({ ...args, underline: patch.isUnderlined });
    }

    return {
        position,
        styles: (fText.styles ?? {}) as unknown as TTextStyles,
    };
}

export { applyTextStyleToFabric };
